import { render, staticRenderFns } from "./relievePreservationNew.vue?vue&type=template&id=83f9b054&scoped=true&"
import script from "./relievePreservationNew.vue?vue&type=script&lang=js&"
export * from "./relievePreservationNew.vue?vue&type=script&lang=js&"
import style0 from "./relievePreservationNew.vue?vue&type=style&index=0&id=83f9b054&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f9b054",
  null
  
)

export default component.exports